import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { request, METHOD } from '@/utils/request';

// 获取工资列表
export function getSalaryList(_x) {
  return _getSalaryList.apply(this, arguments);
}

// 保存工资记录
function _getSalaryList() {
  _getSalaryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(queryInfo) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/salaryController/getSalaryList', METHOD.POST, {
            queryInfo: queryInfo
          }));
      }
    }, _callee);
  }));
  return _getSalaryList.apply(this, arguments);
}
export function saveSalary(_x2) {
  return _saveSalary.apply(this, arguments);
}

// 更新工资记录
function _saveSalary() {
  _saveSalary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(salary) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/salaryController/saveSalary', METHOD.POST, {
            salaryEntity: salary
          }));
      }
    }, _callee2);
  }));
  return _saveSalary.apply(this, arguments);
}
export function updateSalary(_x3) {
  return _updateSalary.apply(this, arguments);
}

// 删除工资记录
function _updateSalary() {
  _updateSalary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(salary) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request('/salaryController/updateSalary', METHOD.POST, {
            salaryEntity: salary
          }));
      }
    }, _callee3);
  }));
  return _updateSalary.apply(this, arguments);
}
export function deleteSalary(_x4) {
  return _deleteSalary.apply(this, arguments);
}

// 根据ID获取工资详情
function _deleteSalary() {
  _deleteSalary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request('/salaryController/deleteSalary', METHOD.POST, {
            id: id
          }));
      }
    }, _callee4);
  }));
  return _deleteSalary.apply(this, arguments);
}
export function getSalaryById(_x5) {
  return _getSalaryById.apply(this, arguments);
}

// 更改工资状态
function _getSalaryById() {
  _getSalaryById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request('/salaryController/getSalaryById', METHOD.POST, {
            id: id
          }));
      }
    }, _callee5);
  }));
  return _getSalaryById.apply(this, arguments);
}
export function changeSalaryStatus(_x6) {
  return _changeSalaryStatus.apply(this, arguments);
}

// 导入工资数据
function _changeSalaryStatus() {
  _changeSalaryStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(salary) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request('/salaryController/changeStatus', METHOD.POST, {
            salaryEntity: salary
          }));
      }
    }, _callee6);
  }));
  return _changeSalaryStatus.apply(this, arguments);
}
export function importSalaryData(_x7) {
  return _importSalaryData.apply(this, arguments);
}

// 下载工资总表模板
function _importSalaryData() {
  _importSalaryData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(formData) {
    var token, response;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
          _context7.n = 1;
          return fetch('/api/salaryController/importSalary', {
            method: 'POST',
            headers: {
              'Authorization': token
            },
            body: formData
          });
        case 1:
          response = _context7.v;
          if (!response.ok) {
            _context7.n = 3;
            break;
          }
          _context7.n = 2;
          return response.json();
        case 2:
          return _context7.a(2, _context7.v);
        case 3:
          throw new Error('Network error');
        case 4:
          return _context7.a(2);
      }
    }, _callee7);
  }));
  return _importSalaryData.apply(this, arguments);
}
export function downloadSalaryTemplate() {
  return _downloadSalaryTemplate.apply(this, arguments);
}

// 下载奖励性绩效明细表模板
function _downloadSalaryTemplate() {
  _downloadSalaryTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request('/salaryController/downloadSalaryTemplate', METHOD.GET));
      }
    }, _callee8);
  }));
  return _downloadSalaryTemplate.apply(this, arguments);
}
export function downloadPerformanceTemplate() {
  return _downloadPerformanceTemplate.apply(this, arguments);
}

// 获取工资导入记录列表
function _downloadPerformanceTemplate() {
  _downloadPerformanceTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request('/salaryController/downloadPerformanceTemplate', METHOD.GET));
      }
    }, _callee9);
  }));
  return _downloadPerformanceTemplate.apply(this, arguments);
}
export function getSalaryImportRecordList(_x8) {
  return _getSalaryImportRecordList.apply(this, arguments);
}

// 获取工资总表明细
function _getSalaryImportRecordList() {
  _getSalaryImportRecordList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(params) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request('/salaryController/getSalaryImportRecordList', METHOD.POST, params));
      }
    }, _callee0);
  }));
  return _getSalaryImportRecordList.apply(this, arguments);
}
export function getSalaryTotalList(_x9) {
  return _getSalaryTotalList.apply(this, arguments);
}

// 获取奖励性绩效明细
function _getSalaryTotalList() {
  _getSalaryTotalList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(params) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request('/salaryController/getSalaryTotalList', METHOD.POST, params));
      }
    }, _callee1);
  }));
  return _getSalaryTotalList.apply(this, arguments);
}
export function getSalaryDetailList(_x0) {
  return _getSalaryDetailList.apply(this, arguments);
}

// 导出工资总表明细
function _getSalaryDetailList() {
  _getSalaryDetailList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(params) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request('/salaryController/getSalaryDetailList', METHOD.POST, params));
      }
    }, _callee10);
  }));
  return _getSalaryDetailList.apply(this, arguments);
}
export function exportSalaryTotalList(_x1) {
  return _exportSalaryTotalList.apply(this, arguments);
}

// 导出奖励性绩效明细
function _exportSalaryTotalList() {
  _exportSalaryTotalList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(params) {
    var token, response;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
          _context11.n = 1;
          return fetch('/api/salaryController/exportSalaryTotalList', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            },
            body: JSON.stringify(params)
          });
        case 1:
          response = _context11.v;
          if (!response.ok) {
            _context11.n = 2;
            break;
          }
          return _context11.a(2, response.blob());
        case 2:
          throw new Error('File export failed');
        case 3:
          return _context11.a(2);
      }
    }, _callee11);
  }));
  return _exportSalaryTotalList.apply(this, arguments);
}
export function exportSalaryDetailList(_x10) {
  return _exportSalaryDetailList.apply(this, arguments);
}

// 获取待发送人员数量
function _exportSalaryDetailList() {
  _exportSalaryDetailList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(params) {
    var token, response;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
          _context12.n = 1;
          return fetch('/api/salaryController/exportSalaryDetailList', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            },
            body: JSON.stringify(params)
          });
        case 1:
          response = _context12.v;
          if (!response.ok) {
            _context12.n = 2;
            break;
          }
          return _context12.a(2, response.blob());
        case 2:
          throw new Error('File export failed');
        case 3:
          return _context12.a(2);
      }
    }, _callee12);
  }));
  return _exportSalaryDetailList.apply(this, arguments);
}
export function getPendingSendCount(_x11) {
  return _getPendingSendCount.apply(this, arguments);
}

// 获取所有待发送人员信息
function _getPendingSendCount() {
  _getPendingSendCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(recordId) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request('/salaryController/getPendingSendCount', METHOD.POST, {
            recordId: recordId
          }));
      }
    }, _callee13);
  }));
  return _getPendingSendCount.apply(this, arguments);
}
export function getPendingSendPersons(_x12) {
  return _getPendingSendPersons.apply(this, arguments);
}

// 发送工资条通知
function _getPendingSendPersons() {
  _getPendingSendPersons = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(recordId) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request('/salaryController/getPendingSendPersons', METHOD.POST, {
            recordId: recordId
          }));
      }
    }, _callee14);
  }));
  return _getPendingSendPersons.apply(this, arguments);
}
export function sendSalaryNotice(_x13) {
  return _sendSalaryNotice.apply(this, arguments);
}
function _sendSalaryNotice() {
  _sendSalaryNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(params) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request('/salaryController/sendSalaryNotice', METHOD.POST, params));
      }
    }, _callee15);
  }));
  return _sendSalaryNotice.apply(this, arguments);
}